var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":"20","width":"2"}},[_c('line',{staticStyle:{"stroke":"rgb(0,0,0)","stroke-width":"2"},attrs:{"x1":"0","y1":"0","x2":"0","y2":"25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }